import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, Mail, MapPin } from 'lucide-react';
import { COMPANY } from '../mock';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#163d59] text-white">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 md:grid-cols-3 lg:px-8">
        <div>
          <div className="flex items-center gap-3">
            <img src={COMPANY.logo} alt="E.A. Lead Solutions" className="h-14 w-auto rounded-md bg-white object-contain p-1" />
            <div>
              <p className="font-display text-lg font-bold">E.A. Lead Solutions</p>
              <p className="text-xs text-white/60">{COMPANY.legal}</p>
            </div>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/70">
            Professional home & property services across all London boroughs. Vetted specialists, tailored quotes, no hidden fees.
          </p>
        </div>

        <div>
          <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-[#7cc4a0]">Quick Links</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-white/75">
            <li><Link to="/our-services" className="hover:text-white">Our Services</Link></li>
            <li><Link to="/about-us" className="hover:text-white">About Us</Link></li>
            <li><Link to="/request-a-service" className="hover:text-white">Request a Service</Link></li>
            <li><Link to="/join-our-team" className="hover:text-white">Join Our Team</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact Us</Link></li>
            <li><Link to="/guide" className="hover:text-white">Platform Guide &amp; Help</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-[#7cc4a0]">Get In Touch</h4>
          <ul className="mt-4 space-y-3 text-sm text-white/75">
            <li className="flex items-start gap-3"><MapPin size={18} className="mt-0.5 shrink-0 text-[#7cc4a0]" /> {COMPANY.address}</li>
            <li className="flex items-center gap-3"><MessageCircle size={18} className="shrink-0 text-[#7cc4a0]" /> <a href={`https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(COMPANY.whatsappMsg)}`} target="_blank" rel="noopener noreferrer" className="hover:text-white">WhatsApp ({COMPANY.whatsappHours})</a></li>
            <li className="flex items-center gap-3"><Mail size={18} className="shrink-0 text-[#7cc4a0]" /> <a href={`mailto:${COMPANY.email}`} className="hover:text-white">{COMPANY.email}</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-5 py-5 text-xs text-white/55 md:flex-row lg:px-8">
          <p>{`Copyright \u00a9 ${year} E.A. Lead Solutions \u2014 Company No. ${COMPANY.companyNumber}`}</p>
          <p>{COMPANY.legal}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
